<template>
    <div v-if="!loading">
        <template v-for="(expert, index) in experts" :key="index">
            <Collapse
                    v-model:activeKey="activeExpert"
                    :bordered="false"
						>
                <template #expandIcon="{ isActive }">
                    <caret-right-outlined :rotate="isActive ? 90 : 0" />
                </template>
                <CollapsePanel :key="index">
                    <template #header>
                        <p class="expert_expend" style="display: flex; align-items: center">
<!--                            <img class="expert_avatart"-->
<!--                                 :src="uploaded_user_image_asset(expert)"-->
<!--                                 style="width: 60px"-->
<!--                                 alt="">-->

														<ImageRender class-name="expert_avatart" :style="{width: '60px'}" :src="getUserAvatar(expert.avatar)"></ImageRender>


                            <strong>{{ expert.fio }}</strong></p>
										</template>
										<div v-for="(category,index) in expert.categories" :key="index">
                        <EditExpertTable
													:category="category"
													:expert="expert"
												></EditExpertTable>
										</div>
								</CollapsePanel>
						</Collapse>
        </template>
    </div>
		<div v-else>
				<Spin></Spin>
		</div>
</template>

<script>
import axios from "axios";
import userService from "@/services/userService";
import { Collapse, CollapsePanel, Spin, Table } from 'ant-design-vue';
import { CaretRightOutlined, SearchOutlined } from '@ant-design/icons-vue';
import EditExpertTable from "@/components/EditExpertTable.vue";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

export default {
  name: "EditExpert",
  components: {
    Collapse,
    CaretRightOutlined,
    CollapsePanel,
    SearchOutlined,
		Spin,
		Table,
    EditExpertTable,
    ImageRender
	},
  data() {
    return {
      loading: false,
      experts: [],
      activeExpert: [],
			activeTours: [],
			competition: null,

    }
  },
  async created() {
    this.loading = true;
    const items = await axios.get('/competition/get_experts_by_competition/' + this.competition_id);
    this.experts = items.data;

    const competition_data = await axios.get('/api/competitions/'+this.competition_id);
    this.competition = competition_data.data;
		this.loading = false;
  },
	methods: {
    // uploaded_user_image_asset(expert) {
    //   return userService.getUploadedUserImageAssetPath(expert.avatar);
		// },
    getUserAvatar(avatar) {
      return ImageService.getUserImagePath(avatar);
    }
  },
  computed: {
    competition_id() {
      return window.competition_id;
    }
  }
}
</script>

<style scoped>

</style>